import _defineProperty from "/codebuild/output/src2417502137/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/codebuild/output/src2417502137/src/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "activeClassName"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useRouter } from "next/router";
import Link from "next/link";
import React, { Children } from "react";
import { jsx as _jsx } from "react/jsx-runtime";

var ActiveLink = function ActiveLink(_ref) {
  var children = _ref.children,
      activeClassName = _ref.activeClassName,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useRouter = useRouter(),
      asPath = _useRouter.asPath;

  var child = Children.only(children);
  var childClassName = child.props.className || "";
  var className = asPath === props.href ? "".concat(childClassName, " ").concat(activeClassName).trim() : childClassName;
  return /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/React.cloneElement(child, {
      className: className || null
    })
  }));
};

export default ActiveLink;